module.exports = __webpack_public_path__ + "img/players.5fe51265.png";